<template>
  <div style="height:100%">
  <div class="pt-2 d-flex" style="overflow-y: hidden; height: 100%">
    <v-card flat class="d-flex flex-column flex-grow-1 flex-shrink-1">
      <v-form class="flex-grow-0 flex-shrink-0">
        <v-row no-gutters align="center" >
          <v-col cols="12" sm="1" style="text-align: right">
            <label>选择门店：</label>
          </v-col>
          <v-col cols="12" sm="3">
            <pd-shop-multiple-list
                v-model="filter.shopIds"
                isSearch
            ></pd-shop-multiple-list>
          </v-col>
          <v-col cols="12" sm="3"></v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" class="mr-2" depressed @click="handleSearch" v-if="_hasButtonPermission('查询')"
            >查询</v-btn
            >
            <v-btn depressed @click="handleResetSearch" v-if="_hasButtonPermission('查询')">重置</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <div class="flex-grow-1 flex-shrink-1" style="position: relative">
        <div style="position: absolute; inset: 0px">
      <v-data-table
          :headers="headers"
          fixed-header
          height="calc(100% - 59px)"
          style="height: 100%"
          :items="desserts"
          class="elevation-1 mt-2"
          :loading="loading"
          :server-items-length="totalDesserts"
          :page.sync="filter.pageNum"
          :items-per-page.sync="filter.pageSize"
          @update:page="handlePageChanged"
          @update:items-per-page="handlePageSizeChanged"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn text color="primary" small @click="viewDetail(item)" v-if="_hasButtonPermission('查询')"
          >排班</v-btn>
        </template>
      </v-data-table>
        </div>
      </div>
    </v-card>
  </div>
  </div>
</template>

<script>
import SchedulingApi from "@/api/pd/inspection/SchedulingApi";

export default {
  name: "List",
  props: {
    buttonPriviledgeList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      filter: {
        shopIds: [],
        pageNum: 1,
        pageSize: 15
      },
      headers: [
        {
          text: "门店名称",
          value: "shopName",
          sortable: false,
          width: 90,
          divider: true,
        },
        {
          text: "物管人员人数",
          value: "personNum",
          sortable: false,
          width: 180,
          divider: true,
        },
        {
          text: "最后修改人",
          sortable: false,
          value: "updateBy",
          width: 100,
          divider: true,
        },
        {
          text: "最后修改时间",
          sortable: false,
          value: "updateTime",
          width: 90,
          divider: true,
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
          width: 220,
          divider: true,
        },
      ],
      desserts: [{}],
      loading: false,
      totalDesserts: 0,

    };
  },
  methods: {
    handleSearch() {
      // 校验门店必选
      if(!this.filter.shopIds||this.filter.shopIds.length==0){
        this.$dialog.error({
          title:'错误',
          text:'请选择门店'
        })
        return
      }
      this.getDataFromApi();
    },
    handleResetSearch() {
      this.filter = {
        shopIds: [],
        pageNum: 1,
        pageSize: 15
      };
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum;
      this.getDataFromApi();
    },
    handlePageSizeChanged(pageSize) {
      if (pageSize == -1) {
        pageSize = 100;
      }
      this.filter.pageNum = 1;
      this.filter.pageSize = pageSize;
      this.getDataFromApi();
    },
    async getDataFromApi() {
      let me = this;
      me.loading = true;
      let queryUserResp = await SchedulingApi.list({
        shopIds: me.filter.shopIds.join(','),
        pageNum: me.filter.pageNum,
        pageSize: me.filter.pageSize
      });
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取排班列表失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      if (!data.data || !data.data.rows) {
        me.loading = false;
        throw new Error("获取排班列表情况失败(无会话数据)");
      }
      me.loading = false;
      me.desserts = data.data.rows;
      me.totalDesserts = data.data.total;
    },
    viewDetail(item){
      this.$emit("viewDetailCallback", {formStatus:'detail',shopId:item.shopId})
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList;
      let hasButton = false;
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == "Y") {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },
  }
}
</script>

<style scoped>

</style>